import { render, staticRenderFns } from "./PendingApprover.vue?vue&type=template&id=2c403e74&scoped=true"
import script from "./PendingApprover.vue?vue&type=script&lang=js"
export * from "./PendingApprover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c403e74",
  null
  
)

export default component.exports